module.exports = __webpack_public_path__ + "static/media/44C72992-15AE-4059-A699-57EC9CB43010.4791f1f8.jpeg";